module.exports = __webpack_public_path__ + "img/BRJ.ef56f5ef.png";